import React, { useEffect, useRef, useState } from "react"
import { isMobile } from "react-device-detect"
import Container from "../components/base/container"
import PageLayout from "../components/base/page-layout"
import Heading from "../components/common/heading"
import LoanCalculatorForm from "../components/loanCalculator/loan-calculator-form"
import LoanPaymentDetail from "../components/loanCalculator/loan-payment-detail"
import { recordPageView } from "../utils/utility"

const LoanCalculator = () => {
  const [data, setData] = useState(null)
  const myRef = useRef()

  useEffect(() => {
    recordPageView("/loan-calculator.html")
  }, [])

  const onCalculate = (data) => {
    setData(data)
    myRef.current.scrollIntoView({
      behavior: "auto",
    })
  }

  return (
    <>
      <PageLayout
        pageTitle="Home Loan Calculator"
        headTitle="Home Loan Calculator Pakistan - Lamudi.pk"
        pageSubTitle="Home Finance and Loan against property in Pakistan"
        description="Best home loan rates in Pakistan. Find out mortgage details for house loan in Pakistan. Estimate your payment plan and monthly installments by Lamudi.pk's easy-to-use home loan calculator."
        verticalAlignment="flexYcenter"
        bannerComponent={!isMobile ? <LoanCalculatorForm onCalculate={onCalculate} /> : null}
      >
        <Container className="u-mb24">
          {isMobile ? <LoanCalculatorForm onCalculate={onCalculate} isMobile={isMobile} /> : null}
          <div ref={myRef}>{data && <LoanPaymentDetail data={data} />}</div>
          <Heading variant="h2">How to apply for home loan?</Heading>
          <p>Everyone dreams of owning a home at some point in their life.</p>
          <p>
            This ideal, however, is not easily achievable, as building or buying a home normally proves to be a very
            costly endeavor. In addition to locating some suitable piece of real estate (for which{" "}
            <a href="https://www.lamudi.pk" title="Lamudi.pk">
              {" "}
              Lamudi.pk{" "}
            </a>{" "}
            proves it's usefulness to no end!), there are a number of developmental issues that you need to contend
            with.
          </p>
          <p>
            This does not mean that you should become disheartened with the entire venture, though – and quit early.
          </p>
          <p>
            These days, there are numerous home financing options available in the market, with almost every major bank
            trying to cater to this pressing consumer demand in the best way that it knows how. Apart from providing the
            funds for home constructions, banks also offer loans for pursuing a timely home renovation spree – and, most
            importantly, for purchasing the land on which your home will be built.
          </p>
          <p>Now if you’re confused about how you can score a decent home loan in Pakistan, there’s no need to fret!</p>
          <p>
            With just a little bit of research, you’ll be able to find (and contact) the bank which is best suited for
            providing a home loan to meet your particular financing/payment needs.
          </p>
          <p>
            Your eligibility for home financing depends on a variety of factors, ranging from your salary to your
            nationality. Also, different banks follow different standards when it comes to approving home loan
            applications; so to figure out the best bank in Pakistan for your home loan request, you need to weigh your
            options carefully.
          </p>

          <p>
            In addition, the loan amount sanctioned, as well the duration you have to repay it over, may vary from bank
            to bank. Your debt-to-equity ratio is also an important determinant, so make sure that you have a strong
            case to present when submitting your loan application.
          </p>
        </Container>
      </PageLayout>
    </>
  )
}

export default LoanCalculator
